import { render, staticRenderFns } from "./CustomerCommentAsText.vue?vue&type=template&id=d20a5fee&scoped=true"
import script from "./CustomerCommentAsText.vue?vue&type=script&lang=js"
export * from "./CustomerCommentAsText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20a5fee",
  null
  
)

export default component.exports